<template>
    <div class="radar_video_block">
        <slick ref="slickOne" :options="slickOptions"  class="radar_banner-slider stick-dots" @init="handleInit" @afterChange="handleAfterChange">
            <div class="slide"  v-for="index in 44" :key="index">
                <a :href='"https://namamedical.org/app/images/video-slider/"+index+"-100.jpg"'>
                    <img  :src='"../../assets/images/video-slider/"+index+"-100.jpg"'/>
                </a>
            </div> 
        </slick>
    </div>
</template>
<script>
import Slick from 'vue-slick';
import axios from 'axios'
import 'slick-carousel/slick/slick.css';

export default {
    name: 'RadarSlider',
    components: { Slick },
    data() {
        return {
            slickOptions: {
                dots: false,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 10000,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover:false,
                // Any other options that can be got from plugin documentation
            },
            banners:null,
            hostname:this.$hostname,
            locale:this.$i18n_global.locale,
            banner_loading:true
        }
    },
    methods: {
        getImageName(index){
        	return "../../assets/images/video-slider/"+index+"-100.jpg";
            // return "https://testuc222.sirv.com/Images/NAMA/video-slider/"+index+"-100.jpg";
        },
        handleInit(event, slick) {
            var _self = this;
            setTimeout(function(){
                _self.$refs.slickOne.next();
            },5000);
        },
        handleAfterChange(event, slick, currentSlide) {
            var _self = this;
            if(currentSlide == 0){
                setTimeout(function(){
                    _self.$refs.slickOne.next();
                },5000);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/RadarSlider.vue